import { render, staticRenderFns } from "./signup-list.vue?vue&type=template&id=2d90d0b6&scoped=true"
import script from "./signup-list.vue?vue&type=script&lang=js"
export * from "./signup-list.vue?vue&type=script&lang=js"
import style0 from "./signup-list.vue?vue&type=style&index=0&id=2d90d0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d90d0b6",
  null
  
)

export default component.exports